( function () {
	'use strict';

	function Groups ( $q, dataservice, logger, collectionService, groupIndexService ) {
		var self = this;

		self.title = 'Sections';

		function setContainer ( groupState ) {
			groupIndexService.setContainer( groupState );
		}

		function setIndex ( index ) {
			groupIndexService.setIndex( index );
		}

		function getIndex () {
			return groupIndexService.getIndex();
		}

		function activate () {
			logger.info( 'Activated Groups View' );
		}

		function removeGroupHandler ( group ) {
			collectionService.removeModel( self.collection, group );
		}

		function moveUpGroupHandler ( group ) {
			collectionService.moveModel( self.collection, group, collectionService.moveUp );
		}

		function moveDownGroupHandler ( group ) {
			collectionService.moveModel( self.collection, group, collectionService.moveDown );
		}

		self.removeGroupHandler   = removeGroupHandler;
		self.moveUpGroupHandler   = moveUpGroupHandler;
		self.moveDownGroupHandler = moveDownGroupHandler;
		self.setContainer         = setContainer;
		self.setIndex             = setIndex;
		self.getIndex             = getIndex;

		activate();
	}

	angular
		.module( 'app.templates' )
		.controller( 'Groups', Groups );

	Groups.$inject = [ '$q', 'coreservice', 'logger', 'collectionService', 'groupIndexService' ];
} )( );
